<template>
  <div class="auth-form-container">
    <Logo />
    <SignupForm />
    <p class="signup-link"><router-link to="/login">Login</router-link></p>
  </div>
</template>

<script>
import SignupForm from "@/components/molecules/SignupForm";
import Logo from "@/components/atoms/Logo";

export default {
  components: {
    SignupForm,
    Logo,
  },
};
</script>